export default "https://cdn-static.gokick.com/assets/1a6b0e419037e7f05bc52ad73a019b5bb7bc4745/images/choco-chill.f91442e53028d067e0a40cd80e4e8aae.png";